import styled from 'styled-components'


export const FooterMenu = styled.div`
    width: 100%;
    background: url('images/back_footer.png') #eee;
    padding: 50px 0 20px 0;
    color:#fff;
    margin-top: 100px;
    background-size: cover;
    
`
export const Container = styled.div`
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
    @media (min-width: 768px) {
        width: 750px;
    }
    @media (min-width: 992px) {
        
        width: 970px;
        
    }
    @media (min-width: 1200px) {
        
        width: 1110px;
        
    }
`
export const Row = styled.div`
   margin: 0;
   width: 100%;
   padding: 0 10px;
   float: left;
`

export const Colseis = styled.div`
   float: left;
   width: 100%;
   @media (min-width: 768px) { 
      width: 50%;
   }
   @media (min-width: 992px) { 
      width: 50%;
   }
   @media (min-width: 1200px) { 
      width: 50%;
   }
   
`

export const Coltres = styled.div`
   width: 100%;
   float: left;
   border: #f00 solid px;
   @media (min-width: 768px) { 
      width: 25%;
   }
   @media (min-width: 992px) { 
      width: 25%;
   }
   @media (min-width: 1200px) { 
      width: 25%;
   }
   
`



export const Menu = styled.ul`
    display:flex;
    flex-direction: row;
    text-align: center;
    text-decoration: none;
`
export const MenuItem = styled.li`
    margin: 30px 0;
    display: flex;
    opacity: 0.6;

    &:before {
       content: "|";
       margin: 0 10px 0 0;
   }

   &:last-child{
      &:after{
         content: "|";
       margin: 0 10px 0 0;
      }
   }
`
export const Links = styled.a`
   color: #FFF;
   font-size: 12px;
   text-align: center;
   margin: 0 10px;
   display: flex;
   align-items: flex-end;
   text-decoration:none;
   font-family: 'Open Sans', sans-serif;
   letter-spacing: 0.48px;
  

   & svg {
      margin-left: 5px;
   }

   
`

export const Linkshare = styled.a`
    color:#fff;
    margin-left:10px;
   
   :hover{
    color:#fff;
   }
`
export const Iconfooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #d9a76a;
    border-radius: 50px;
    width: 40px;
    height: 40px;
    margin-right:5px;
    &:hover{
       background:#fff;
    }
`
